import { useContext } from 'react';

import styled from '@emotion/styled';

import { ModalContext } from '../../../context/ModalContext';
import ModalContainer from '../ModalContainer';
import useJobPermissions from '../../../hooks/jobs/useJobPermissions';

interface DeletePostedJobModalProps {
  proceedDel: () => void;
  jobId: string;
}

const DeletePostedJobModal: React.FC<DeletePostedJobModalProps> = ({
  proceedDel,
  jobId,
}) => {
  const modalContext = useContext(ModalContext);
  // Pass the showModal flag to the hook so it only runs when modal is visible.
  useJobPermissions(jobId, modalContext?.showModal ?? false);

  return (
    <ModalContainer>
      <Container>
        <Text>Are you sure you want to delete this Job?</Text>
        <ButtonArea>
          <DeleteBtn onClick={proceedDel}>Yes, Delete</DeleteBtn>
          <CancelBtn
            onClick={() => {
              modalContext?.displayModal(false);
            }}
          >
            Cancel
          </CancelBtn>
        </ButtonArea>
      </Container>
    </ModalContainer>
  );
};

export default DeletePostedJobModal;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 38px;
  justify-content: center;
  align-items: center;

  @media (max-width: 480px) {
    align-items: flex-start;
  }
`;

const Text = styled.div`
  color: ${({ theme }) => theme.palette.blackBlackMain};
  font-size: 24px;
  font-weight: 400;
  width: 248px;
  text-align: center;

  @media (max-width: 480px) {
    font-size: 20px;
    text-align: left;
  }
`;

const CancelBtn = styled.div`
  background: ${({ theme }) => theme.palette.greyGrey1};
  color: white;
  cursor: pointer;
  width: fit-content;
  border-radius: 4px;
  display: grid;
  place-content: center;
  padding: 8px 48px;
  font-weight: 500;
  font-size: 14px;
`;

const DeleteBtn = styled(CancelBtn)`
  background-color: ${({ theme }) => theme.palette.stateColorRed};
`;

const ButtonArea = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 16px;
    width: 100%;

    & > * {
      width: 100%;
    }
  }
`;
